import { connect } from 'react-redux'
import { createAuthStateToProps } from 'helpers/auth'
import actions from 'actions/suppliers'
import Component from 'components/DraftOrder/Items/Filter'

const mapStateToProps = (state, props) => ({ ...createAuthStateToProps(state, props) })

export default connect(mapStateToProps, { getSuppliers: actions.getOptionsOffline })(Component)
